<template>
  <div>
    <div v-if="isMobileDevice" class="overlay mobile_only"></div>
    <div class="fixed_page"  id="blurry">
      <div class="get-started">
        <div class="home-main">
          <div class="fixed_page">

            <div class="home_stats_box">
              <div class="home_row flex-row">
                <div class="flex-column">
              <div class="home_edit_icon_bg" @click.prevent="toEdit()" style="cursor: pointer">

              <img :src="editIconSrc" class="home_edit_icon">
              </div>

                  <img :src= "userDetails.avatar"  class="avatar_home">
                </div>
                <div class="flex-column home_user_info">
                  <h4>{{ userDetails.username }}</h4>
                  <p> {{ getTranslations.home_game_iq }}
                  <span> {{ userDetails.iqPoints }} </span></p>
                  <p> {{ getTranslations.home_collected_points }} <span>{{ userDetails.totalPointsEarned }}</span></p>
                  <p> {{ getTranslations.home_profile_profile_games }} <span>{{ userDetails.gamesPlayed }}</span></p>
                </div>
              </div>
              <button class="fb_bg" v-if="facebookFunctionality">
                <div class="home_row">
                  <img src="static/images/home/logo-facebook.svg">
                  <p> {{ getTranslations.visitor_facebook_login_connect_before_points }} <br>
                    {{ getTranslations.visitor_facebook_login_connect_before_points_to_earn }}
                    {{ connectionPoints }} {{ getTranslations.visitor_facebook_login_connect_after_points }}</p>
                </div>
              </button>
              <div class="games_left_row">
                <p @click.prevent="openUnlockedModal" style="cursor: pointer"><span>{{ userDetails.availableGames }}</span>
                  {{ getTranslations.home_games_left }} </p>
                <a v-if="!hideStore" @click.prevent="toStorePage" style="cursor: pointer">{{ getTranslations.home_buy_games }}</a>
              </div>
            </div>

            <div class="select_game_title">{{ getTranslations.home_select_game_play }} </div>
            <!-- start_circle -->
            <div class="circle_background">
              <div class="home_select_game">

                <div class="desktop_games">
                  <div class="game_box logic" @click.prevent="navigateToGameIntro('LOGIC')" style="cursor:pointer">
                    <img src="static/images/games/icon-logic.png">
                    <p> {{ getTranslations.home_gametype_logic }} </p>
                  </div>
                  <div class="game_box memory" @click.prevent="navigateToGameIntro('MEMORY')" style="cursor:pointer">
                    <img src="static/images/games/icon-memory.png">
                    <p> {{ getTranslations.home_gametype_memory }} </p>
                  </div>
                  <div class="game_box attention" @click.prevent="navigateToGameIntro('ATTENTION')" style="cursor:pointer">
                    <img src="static/images/games/icon-attention.png">
                    <p> {{ getTranslations.home_gametype_attention }} </p>
                  </div>
                </div>

                <games-carousel-mobile> </games-carousel-mobile>

              </div>

              <div class="home_prizes_section">
                <div class="col-lg-12">
                  <h1> {{ getTranslations.home_train_brain }} <span class="make_bold">
                    {{ getTranslations.home_win_more }} </span></h1>
                  <p> {{ getTranslations.home_unlock_chance_win }}
                    <span class="make_bold"> {{ getTranslations.home_grand_prize_draw }} </span>
                    {{ getTranslations.home_grand_prize_worth }} <span class="make_bold">
                      {{ getTranslations.visitor_grand_prize_value }}</span></p>
                </div>
                <div class="col-lg-12">
                  <h1><span class="make_bold prizes_home_title"> {{ getTranslations.home_home_prizes }} </span></h1>
                  <p> {{ getTranslations.home_check_prizes }} </p>
                </div>
              </div>

              <carousel></carousel>

              <div class="desktop_only" v-if="!!phaseBonusList.length">
                <span v-for="(phase,index) in phaseBonusList" :key="index">
                  <bonus-box v-if="phase.type === 'BUNDLES'" :phase=phase :is-midnight-bonus="true" @isMobileDeviceMethod="isMobileDevice = false"></bonus-box>
                  <bonus-box v-if="phase.type === 'POINTS'" :phase=phase :is-midnight-bonus="false" @isMobileDeviceMethod="isMobileDevice = false"></bonus-box>
                </span>
              </div>
              <div class="mobile_only" v-if="!!phaseBonusList.length">
                <span v-for="(phase, index) in phaseBonusList" :key="index">
                  <bonus-box-mobile v-if="phase.type === 'BUNDLES'" :phase=phase :index=index
                                    :length=phaseBonusList.length :is-midnight-bonus="true" @isMobileDeviceMethod="isMobileDevice = true"></bonus-box-mobile>
                  <bonus-box-mobile v-if="phase.type === 'POINTS'" :phase=phase :index=index
                                    :length=phaseBonusList.length :is-midnight-bonus="false" @isMobileDeviceMethod="isMobileDevice = true"></bonus-box-mobile>
                </span>
              </div>
              <achievements-profile></achievements-profile>
            </div>
            <!-- end circle -->
          </div>
        </div>
      </div>
    </div>

    <resume-game-modal v-if="isResumeGameModalOpen" @resume:game="handleResumeGame"></resume-game-modal>

    <pre-lantern-game-modal
      v-if="addOnGamePreModalConfiguration.isLanternOpen"
      :can-play="addOnGamePreModalConfiguration.canPlay"
      @play:lantern="handlePlayLanternGame"
    />

    <pre-puzzle-game-modal
      v-if="addOnGamePreModalConfiguration.isPuzzleOpen"
      :can-play="addOnGamePreModalConfiguration.canPlay"
      @play:puzzle="handlePlayPuzzleGame"
    />

    <div class="bonus_phase_outer" v-if="showOptOutPhase">
      <div class="bonus_phase promo_phase_fp" id="optout">
        <div class="bonus_phase_inner ">
          <div class="promo_phase_outer">
            <div class="bonus_phase_content promo_phase_fp">
              <p> {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_message') }} <a class="optout__link" @click.prevent="toEdit">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_click_here') }}</a></p>
            </div>
          </div>
        </div>
        <button class="bonusclose"  id="bonusclose" @click="closeBannerForOptout()"></button>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off" */
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { closeBanner } from '@/common/jQuery';
import 'owl.carousel';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import SkinMixin from '@/common/mixins/skin';
import executionChainMixin from '../../common/mixins/executionChain';
import modals from '@/common/modals';
import PreLanternGameModal from '@/components/common/modal/game/PreLanternGameModal';
import PrePuzzleGameModal from '@/components/common/modal/game/PrePuzzleGameModal';
import ResumeGameModal from './modals/ResumeGameModal';
import PreGameModal from './modals/pregame/PreGameModal';
import UnlockedGamesModal from './modals/unlockedgames/UnlockedGamesModal';
import UnlockedGamesZeroBalanceModal from './modals/unlockedgames/UnlockedGamesZeroBalanceModal';
import Carousel from './Carousel';
import BonusBox from './BonusBox';
import BonusBoxMobile from './BonusBoxMobile';
import GamesCarouselMobile from './GamesCarouselMobile';
import AchievementsProfile from './profile/AchievementsProfile';
import {removeLocalStorageValueByUser} from '../../helpers/user';


export default {
  name: 'default-content',
  components: {
    PrePuzzleGameModal,
    PreLanternGameModal,
    ResumeGameModal,
    AchievementsProfile,
    GamesCarouselMobile,
    BonusBox,
    UnlockedGamesZeroBalanceModal,
    UnlockedGamesModal,
    PreGameModal,
    Carousel,
    BonusBoxMobile,
  },
  data() {
    return {
      isMobileDevice: false,
      isResumeGameModalOpen: false,
      addOnGamePreModalConfiguration: {
        isLanternOpen: false,
        isPuzzleOpen: false,
        canPlay: false,
      },
    };
  },
  mixins: [NumbersFormattingMixin, SkinMixin, executionChainMixin],
  beforeDestroy() {
    this.setBonusPhasesNum(this.phaseBonusList.length);
  },
  mounted() {
    closeBanner();
  },
  created() {
    this.executionChainMixinSetMethodList([
      this.checkIsGameInProgress,
      this.checkDailyBonus,
      this.checkAddOnGame,
    ]);

    this.executionChainController.launch();
  },
  methods: {
    ...mapMutations('game', [
      'updateGameType',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
      'setAddOnGameConfig',
    ]),
    ...mapMutations('profile', [
      'setBonusPhasesNum',
      'setIsAddonGameModalShown',
    ]),
    ...mapActions('game', [
      'getAddOnGameStatus',
    ]),
    checkIsGameInProgress () {
      if (localStorage.getItem('isGameInProgress')) {
        const isGameInProgress = removeLocalStorageValueByUser('isGameInProgress', this.userDetails.msisdn);

        if (isGameInProgress) {
          this.isResumeGameModalOpen = true;

          modals.setupCommonModal({
            afterHideCallback: () => {
              this.isResumeGameModalOpen = false;

              this.executionChainController.next()
            }
          })

          return;
        }
      }

      this.executionChainController.next();
    },
    handleResumeGame () {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.isResumeGameModalOpen = false;

          this.navigateToGameIntro('LOGIC');
        }
      });
    },
    checkDailyBonus() {
      if (this.bonusDailyModal) {
        const unwatch = this.$watch('bonusDailyModal', (newVal) => {
          if (!newVal) {
            unwatch();
            this.executionChainController.next();
          }
        });
      } else {
        this.executionChainController.next();
      }
    },
    async checkAddOnGame () {
      if (
        (this.lanternGame || this.puzzleGame) &&
        !this.isAddOnGameModalShown
      ) {
        this.setIsAddonGameModalShown(true);

        let gameId = null;

        if (this.lanternGame) {
          gameId = this.lanternGame.id;
        } else if (this.puzzleGame) {
          gameId = this.puzzleGame.id;
        }

        try {
          const queryParams = {
            gameId,
            msisdn: this.userDetails.msisdn,
          };

          const addOnGameStatusResponse = await this.getAddOnGameStatus({ queryParams });

          this.addOnGamePreModalConfiguration.canPlay = addOnGameStatusResponse.canPlay;
        } catch (_e) {
          this.executionChainController.next();

          return;
        }

        if (this.lanternGame) {
          this.addOnGamePreModalConfiguration.isLanternOpen = true;

          modals.setupCommonModal({
            showImmediate: true,
            afterHideCallback: () => {
              this.addOnGamePreModalConfiguration.isLanternOpen = false;
              this.addOnGamePreModalConfiguration.canPlay = false;

              this.executionChainController.next();
            },
          });

          return;
        } else if (this.puzzleGame) {
          this.addOnGamePreModalConfiguration.isPuzzleOpen = true;

          modals.setupCommonModal({
            showImmediate: true,
            afterHideCallback: () => {
              this.addOnGamePreModalConfiguration.isPuzzleOpen = false;
              this.addOnGamePreModalConfiguration.canPlay = false;

              this.executionChainController.next();
            },
          });

          return;
        }
      }

      this.executionChainController.next();
    },
    handlePlayLanternGame () {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.addOnGamePreModalConfiguration.isLanternOpen = false;
          this.addOnGamePreModalConfiguration.canPlay = false;

          this.setAddOnGameConfig({ gameId: this.lanternGame.id });

          this.$router.push({ name: 'addOnGameLantern' });
        },
      });
    },
    handlePlayPuzzleGame () {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.addOnGamePreModalConfiguration.isPuzzleOpen = false;
          this.addOnGamePreModalConfiguration.canPlay = false;

          this.setAddOnGameConfig({
            gameId: this.puzzleGame.id,
            prizeValue: this.puzzleGame.rewardPoints,
          });

          this.$router.push({ name: 'addOnGamePuzzle' });
        },
      });
    },
    toEdit() {
      this.$router.push('/home/profile/edit');
    },
    toStorePage() {
      this.$router.push('/home/store');
    },
    closeBannerForOptout() {
      closeBanner();
    },
    openUnlockedModal() {
      if (this.userDetails.availableGames !== 0) this.storeModalForHomePage(UnlockedGamesModal);
      else this.storeModalForHomePage(UnlockedGamesZeroBalanceModal);
      modals.showHideModal(this);
    },
    navigateToGameIntro(game) {
      this.storeModalForHomePage(PreGameModal);
      this.updateGameType(game);
      modals.showHideModal(this);
    },
  },
  computed: {
    editIconSrc() {
      return this.$_skinImage({ fileName: 'home/icon-edit.svg', skins: [100] });
    },
    ...mapState('common', [
      'modalForHomePage',
      'hideStore',
      'hideJackpot',
      'userDetails',
      'connectionPoints',
      'facebookFunctionality',
      'showOptOutPhase',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapState('profile', [
      'phaseBonusList',
      'bonusPhasesNum',
      'lanternGame',
      'puzzleGame',
      'isAddOnGameModalShown',
      'bonusDailyModal',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/DefaultContent.vue